import * as angular from 'angular';
import ChatServiceName, {ChatService} from "../../services/chat/chat.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import template from "./sendChat.tpl.html";
import {apsCommands} from "../../shared/dto/aps.commands";

let requires = ['mm.foundation', ChatServiceName, LoaderServiceName, NotifyServiceName];

export interface ChatData {
  plantId: string;
  shopId: string;
}

export interface SendChatController {
  message: string;
  form: angular.IFormController;
  sendMessage(): void;
  cancel(): void;
  count: number;
  desc: boolean;
}

export function openSendChat(chatData: ChatData,
                             $modal: mm.foundation.modal): angular.IPromise<apsCommands.AddChatMessage> {
  return $modal.open({
    template: template,
    controller: 'SendChatCtrl as vm',
    resolve: {
      data: () => chatData
    }
  }).result;
}

class SendChatCtrl implements SendChatController {
  count: number;
  desc: boolean;
  message: string;
  form: angular.IFormController;
  private $modalInstance: mm.foundation.modalInstance;
  private chatService: ChatService;
  private loaderService: LoaderService;
  private notifyService: NotifyService;
  private data: ChatData;

  constructor($modalInstance: mm.foundation.modalInstance,
              chatService: ChatService,
              loaderService: LoaderService,
              notifyService: NotifyService,
              data: ChatData) {
    this.$modalInstance = $modalInstance;
    this.chatService = chatService;
    this.loaderService = loaderService;
    this.notifyService = notifyService;
    this.data = data;
    this.count = 5;
    this.desc = true;
  }

  sendMessage(): void {
    if (this.form.$invalid) {
      return;
    }

    let cmd = {
      plantId: this.data.plantId,
      shopId: this.data.shopId,
      message: this.message
    };
    this.loaderService.loadingPromise(
      this.chatService.sendMessage(cmd).then(() => {
        this.$modalInstance.close(cmd);
      }, this.notifyService.handleApiErrors)
    );
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.sendChat', requires)
  .controller('SendChatCtrl', SendChatCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/chat/sendChat.ts